import React, { useEffect, useRef } from 'react';

const Starfield = ({ isDay }) => {
  const canvasRef = useRef(null);
  const starsRef = useRef([]);
  const rafRef = useRef(null);

  // Generate star data once
  useEffect(() => {
    starsRef.current = Array.from({ length: 80 }, () => ({
      x: Math.random(),
      y: Math.random(),
      size: Math.random() > 0.9 ? 2.5 : Math.random() > 0.7 ? 1.5 : 1,
      baseOpacity: 0.5 + Math.random() * 0.4,
      twinkleSpeed: 0.3 + Math.random() * 0.7,
      twinkleOffset: Math.random() * Math.PI * 2,
      glow: Math.random() > 0.9,
    }));
  }, []);

  // Canvas animation loop
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    const draw = (time) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (const star of starsRef.current) {
        const twinkle = Math.sin(time * 0.001 * star.twinkleSpeed + star.twinkleOffset);
        const opacity = star.baseOpacity + twinkle * 0.15;
        const x = star.x * canvas.width;
        const y = star.y * canvas.height;

        if (star.glow) {
          ctx.fillStyle = `rgba(255, 255, 255, ${opacity * 0.15})`;
          ctx.beginPath();
          ctx.arc(x, y, star.size * 3, 0, Math.PI * 2);
          ctx.fill();
        }

        ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`;
        ctx.beginPath();
        ctx.arc(x, y, star.size, 0, Math.PI * 2);
        ctx.fill();
      }
      rafRef.current = requestAnimationFrame(draw);
    };

    rafRef.current = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(rafRef.current);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 pointer-events-none"
      style={{
        opacity: isDay ? 0 : 0.9,
        transition: 'opacity 3s ease-in-out',
      }}
    />
  );
};

export default Starfield;
